<div id="div-news-letter" class="pr-3 pl-3 pt-5 pb-5 w-20">
  <div class="row">
    <div class="col-md-6 pr-5">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <h2>Assine a nossa newsletter</h2>
        <p>
          {{ this.SITE.mensagemNewsletter }}
        </p>
        <div class="form-group">
          <input
            formControlName="nome"
            placeholder="Nome"
            type="text"
            id="input-nome"
            class="form-control"
          />
        </div>
        <div class="form-group">
          <input
            formControlName="email"
            placeholder="Email"
            type="email"
            id="input-email"
            class="form-control"
          />
        </div>
        <button
          id="button-submit"
          type="submit"
          class="btn btn-primary"
          color="black"
        >
          Enviar
        </button>
      </form>
    </div>
    <div class="col-md-2"></div>
    <div class="col-md-2 pl-5">
      <img id="img-newsletter" [src]="imageUrl" />
    </div>
  </div>
</div>
